import { render, staticRenderFns } from "./modal-header.vue?vue&type=template&id=b783264e&scoped=true&lang=pug&"
import script from "./modal-header.vue?vue&type=script&lang=js&"
export * from "./modal-header.vue?vue&type=script&lang=js&"
import style0 from "./modal-header.vue?vue&type=style&index=0&id=b783264e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b783264e",
  null
  
)

export default component.exports